export const ARTICLE_TEMPLATES = [
  { label: 'Add a link', value: `<a href="link here"> text here </a>` },
  { label: 'Bold text', value: `<b> </b>` },
  { label: 'Italic text', value: `<i> </i>` },
];
